<template>
  <div class="mr-3 mt-1">
    <AvatarComponent
      v-if="notifiers.length === 1"
      size="50" class="mr-1" :url="notifiers[0].picture"
    />
    <div v-else class="multiAvatar">
      <v-avatar
        :size="40"
        :style="status === NOTIFY_UNREAD ? 'border-color: rgb(245, 245, 245)' : 'border-color: white'"
        class="avatarUp"
      >
        <v-img alt="Avatar" :src="avatarUrl(notifiers[0].picture)" />
      </v-avatar>
      <AvatarComponent
        size="35" class="avatarDown" :url="notifiers[1].picture"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "NotifyItem",
  props: {
    notifiers: {type: [Object, Array], default: {}},
    status: {type: Number, default: 1}
  }
};
</script>
